
import React, { useMemo } from 'react';
import ArticleAIControls from './article-ai/ArticleAIControls';
import ArticleAIFeature from './article-ai/ArticleAIFeature';
import { Card } from '@/components/ui/card';

interface ArticleAIPanelProps {
  article: any;
}

const ArticleAIPanel: React.FC<ArticleAIPanelProps> = ({ article }) => {
  // Enhanced detection of opinion pieces with more sophisticated criteria
  const isOpinionPiece = useMemo(() => {
    // Check tags for opinion indicators
    const opinionTags = ['opinion', 'perspective', 'viewpoint', 'editorial', 'commentary', 'analysis'];
    const hasOpinionTag = article.tags?.some((tag: string) => 
      opinionTags.includes(tag.toLowerCase())
    ) || false;
    
    // Check title for opinion indicators
    const opinionTitlePhrases = ['opinion:', 'perspective:', 'my take', 'why i think', 'why we should'];
    const hasOpinionTitle = opinionTitlePhrases.some(phrase => 
      article.title?.toLowerCase().includes(phrase)
    );
    
    // Check if the author is marked as an opinion columnist (if that data is available)
    const isOpinionColumnist = article.author?.role === 'opinion_columnist';
    
    // Check if article's content contains phrases that indicate opinion content
    const hasOpinionLeadPhrases = article.lead?.toLowerCase().includes('in my opinion') ||
                                article.lead?.toLowerCase().includes('i believe') ||
                                article.lead?.toLowerCase().includes('i argue');
    
    // For demo purposes, make sure this feature is available
    const forceEnable = true;
    
    return hasOpinionTag || hasOpinionTitle || isOpinionColumnist || hasOpinionLeadPhrases || forceEnable;
  }, [article]);
  
  // Estimate content complexity (in a real implementation, this would be calculated based on readability metrics)
  const contentComplexity = 0.7; // Mock value between 0-1, where 1 is most complex
  
  return (
    <Card className="p-4 mb-6 border-primary/10">
      <ArticleAIControls 
        isOpinionPiece={isOpinionPiece} 
        contentComplexity={contentComplexity} 
      />
      <div className="mt-3">
        <ArticleAIFeature article={article} />
      </div>
    </Card>
  );
};

export default ArticleAIPanel;
